/*
 * @Author: your name
 * @Date: 2021-06-24 18:36:56
 * @LastEditTime: 2023-10-19 13:31:14
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\utils\page-mixin.js
 */
// import { commonApi } from '@/api';
import ElTableColumn from '@/components/ElTableColumn/index.vue';
import moment from 'moment';
import { downloadImageUrl, isCrossDomainDownloadUrl, normalizeDownloadUrl, openDownloadUrl, randomID } from '@/utils/index';

export default {
  components: {
    ElTableColumn,
  },
  data() {
    return {
      /** * 拖拽自定义表头 */
      colSpan: 4,
      labelsVersion: 11, // 不能为 0 或 false
      SortableTable: {
        show: () => {},
        handleHeaderDragend: () => {},
        handleHeaderContextmenu: () => {},
      },
      dropCols: [],
      //
      selectedDataObj: {},
      tags: [], // 选中项 转为 tags ，在表格下方
      pagesSelectedRows: [], // 各页的选中项集合
      selectedRows: [], // 当前页的选中项
      treeTableChildrenSelection: [], //
      expandTableSelectedObj: [],
      selection: true,
      serial: true,
      /** 禁止拖动 */
      sortableTableCode: '', // 同一个路由页面下，多tab页列表的保存Code
      sortTableByOptionName: false,
      tableSortableDisabled: false,

      routerName: '',
      tableObj: {
        title: window.vm.$t('settingText'),
        restore: window.vm.$t('restoreDefaultText'),
        cancel: window.vm.$t('cancelText'),
        ok: window.vm.$t('okText'),
        checkAll: window.vm.$t('checkAllText')
      }
    };
  },
  filters: {
    phoneFilter(val) {
      if (val) {
        const reg = /^(.{3}).*(.{4})$/;
        return val.replace(reg, '$1****$2');
      }
    },
    timeOptimization(date) {
      const regex = /^\d{4}-\d{2}-\d{2}/;
      if (date && !isNaN(new Date(date).getTime()) && regex.test(date)) {
        // if (getLanguage() === 'en') {
          return moment(date).format('DD/MM/YYYY HH:mm');
        // } else {
        //   return moment(date).format('YYYY-MM-DD HH:mm');
        // }
      }
    },
    timeChanges(date) {
      const regex = /^\d{4}-\d{2}-\d{2}/;
      if (date && !isNaN(new Date(date).getTime()) && regex.test(date)) {
          return moment(date).format('DD/MM/YYYY');
      }
    },
    // 异常订单===》计算 超时时长
    timeOutOperate(date) {
      const regex = /^\d{4}-\d{2}-\d{2}/;
      if (date && !isNaN(new Date(date).getTime()) && regex.test(date)) {
        var timeNow = new Date().getTime();
        var orderTime = new Date(date).getTime();
        var timeOut = (timeNow - orderTime) / (1000 * 60 * 60);
        return Math.round(timeOut * 100) / 100;
      }
    },
    timeOperateTwoHour(date) {
      if (date) {
        // 获取澳洲当前时间与本地时间的时差
        const timeHour = sessionStorage.getItem('timeHour') || '2';
        var time = Date.parse(new Date(date));
        var newTime = moment(time + timeHour * 3600000).format('DD/MM/YYYY HH:mm');
        return newTime;
      }
    },
    profitMarginFilter(val) {
      if (val) {
        const result = Number((val * 100).toFixed(2));
        return `${result}%`;
      } else {
        return `0%`;
      }
    }
  },
  computed: {
    BjPageDocumentId() {
      return 'BjPage' + randomID();
    },
    customerList() {
      return this.$store.getters.customerList;
    },
    clientCodeList() {
      return this.$store.getters.clientCodeList;
    },
    customerActivityList() {
      return this.$store.getters.customerActivityList;
    },
    clientCodeActivityList() {
      return this.$store.getters.clientCodeActivityList;
    },
  },
  watch: {
    '$route.name'(v) {
      this.routerName = v;
    },
    'labelList'(v) {
      this.init();
    }
  },
  created() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.$eventHub.$off('refresh' + this.routerName);
    this.SortableTable?.remove?.();
  },
  methods: {
    init() {
      this.routerName = this.$route?.name;
      // 注册刷新事件
      this.$eventHub.$on('refresh' + this.routerName, this.reFresh);
      /** 拖拽自定义表头 */
      let startIndex = 0;
      if (this.selection) startIndex++;
      if (this.serial) startIndex++;
      // 保存的唯一code
      if (!this.sortableTableCode) {
        // 默认取路由name。
        this.sortableTableCode = this.$route?.name;
        if (this.sortTableByOptionName) {
          // 取组件名称
          this.sortableTableCode = this.$options.name;
        }
      }
      this.labelList && this.labelList.map(item => { item.label = this.$t(item.label); return item; });
      this.SortableTable = this.$initElementTableSortable({
        el: `#${this.BjPageDocumentId} .body--wrapper>.vxe-table--header .vxe-header--row`, // '.el-table__header-wrapper tr:last-child',
        tableSortableDisabled: this.tableSortableDisabled,
        dragElement: `#${this.BjPageDocumentId} .vxe-header--column`, // 默认是 className : draggable  .item
        defaultLabels: this.labelList,
        startIndex: startIndex,
        sortableTableCode: this.sortableTableCode, // 唯一key
        labelsVersion: this.labelsVersion, // 当前版本号
        // setRemoteApi: commonApi.saveTabulation, // 非必填
        // getRemoteApi: commonApi.getTabulation, // 非必填
        handleColumn: this.handleColumn,
        tableObj: this.tableObj
      });

      // this.setSortTableCodeAndHeight();

      // 对整个页面滚轮进行监听，每发生一次滚轮事件，执行一次方法
      // window.addEventListener('scroll', this.scrollCallBack, true);
    },
    scrollCallBack() {
      // 兼容性，获取页面滚动距离
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      const IS_BOTTOM = document.body.scrollHeight - scrollTop - document.body.clientHeight < 3;

      this.$refs.BjPage.showSearch = !IS_BOTTOM;
    },
    // setSortTableCodeAndHeight() {
    //   this.$nextTick(() => {
    //     // 根据列表code，获取列表的自定义高度（用于max-height）
    //     const LAST_HEIGHT = Number(localStorage.getItem(this.sortableTableCode) || 0);
    //     // 把 code 和 height 传入 bjPage
    //     if (LAST_HEIGHT) {
    //       this.$refs.BjPage?.setSortTableCodeAndHeight(this.sortableTableCode, LAST_HEIGHT);
    //     }
    //   });
    // },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.handleSelectionChange({});
      return new Promise(resolve => {
        resolve();
      });
    },
    // tooltip 默认显示内容
    showTooltipMethod({ type, column, row, items, _columnIndex }) {
      return row[column.property];
    },
    /** 拖拽自定义表头 */
    handleColumn(data) {
      this.dropCols = data;
      if (this.tableSortableDisabled) return;
      this.$nextTick(() => {
        if (this.$refs.BjPage) {
          this.$refs.BjPage.$refs.BjTable && this.$refs.BjPage.$refs.BjTable.refreshColumn();
        }
      });
    },
    reFresh() {
      this.$refs.BjPage && this.$refs.BjPage.fetchData();
    },
    normalizeDownloadUrl,
    isCrossDomainDownloadUrl,
    openDownloadUrl,
    downloadImageUrl,
    handleSelectionChange(data) {
      this.selectedDataObj = { ...data };
      this.selectedRows = data.selection || [];
      this.tags = data.tags || [];
      this.treeTableChildrenSelection = data.children || [];
      this.pagesSelectedRows = data.pagesSelectedRows || [];
    },
    handleQuery() {
      setTimeout(() => {
        this.reFresh();
      }, 300);
    },
    // 子多选框选中数据
    handleExpandTableSelectionChange(arg) {
      // const {
      //   childrenSelection,
      //   parentRow,
      //   parentIndex,
      //   expandTableIndexSelection,
      //   treeTableChildrenSelection,
      // } = arg;
      this.expandTableSelectedObj = arg;
    }
  },
};
